// @ts-check

const { prevArrow, nextArrow } = require( "../parts/slick-defaults" );

jQuery( function( $ ) {

    $( '.gallery__images' ).slick( {
        // dots: false,
        // autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow,
        nextArrow
    } );
} );
